import { graphql } from "gatsby"
import { Disqus } from "gatsby-plugin-disqus"
import React from "react"
import Badge from "react-bootstrap/Badge"
import PostTemplate from "./post-template"


const SubTitle = ({ tags }) => (
  <div className="mb-5">
    {tags.map(tag => (
      <Badge key={tag} pill variant="dark" className="mb-2 px-3 mr-1">
        <h5 className="text-white my-0">{tag}</h5>
      </Badge>
    ))}
  </div>
)

export default ({ data, location }) => {
  const post = data.markdownRemark

  const { siteUrl } = data.site.siteMetadata

  let disqusConfig = {
    url: `${siteUrl + location.pathname}`,
    identifier: post.frontmatter.id,
    title: post.frontmatter.title,
  }


  return (
    <PostTemplate
      title={post.frontmatter.title}
      subTitle={<SubTitle tags={post.frontmatter.tags} />}
      excerpt={post.excerpt}
      html={post.html}
      childreen={<Disqus config={disqusConfig} />}
      />
  )
}

export const query = graphql`
  query($slug: String!) {
    site {
      siteMetadata {
        siteUrl
      }
    }
    markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      frontmatter {
        title
        tags
      }
      excerpt
    }
  }
`
